import { getContentTypes } from "./orderCompleted.js";
export default function productViewed({
  properties
}) {
  const {
    config
  } = this;
  const quantity = properties.quantity || 1;
  return {
    name: "ViewContent",
    properties: {
      content_ids: [properties.product_id],
      content_type: getContentTypes(properties.category, config),
      content_name: properties.name,
      content_category: properties.category,
      value: properties.price * quantity,
      contents: [{
        id: properties.product_id,
        quantity
      }]
    }
  };
}